/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component} from '@angular/core';
import {ProgramTiming} from '../../model/programTiming';
import {EsciService} from '../../service/esci.service';
import {KtsComponent} from '../kts/kts.component';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'button-cell-renderer',
    styleUrls: ['./cell-renderer.component.scss'],
    template: `
    <div>
      <span [style]="customStyle()">{{ this.programTiming?.date? (this.programTiming?.date | date: 'MM/dd/yyyy') || 'NA' : ''}}</span>
      &nbsp;@if (this.programTiming?.icdsNotOnScheduleLink) {
      <a target="_blank"
        href="{{apiUrl + this.programTiming?.icdsNotOnScheduleLink}}">
        <span class="pi pi-exclamation-triangle"></span>
      </a>
    }
    @if (this.programTiming?.date && showButton) {
      <span>
        <button pButton size="small" pRipple type="button" [disabled]="disableButtons"
        [severity]="disableButtons ? 'secondary' : null"
        class="p-button-rounded p-button-text" (click)="adjustWeeksMinusOne()"><i class="pi pi-minus" pButtonIcon></i></button>
        {{programTiming?.adjustedWeeks}}
        <button pButton size="small" pRipple type="button" [disabled]="disableButtons"
        [severity]="disableButtons ? 'secondary' : null"
        class="p-button-rounded p-button-text" (click)="adjustWeeksPlusOne()"><i class="pi pi-plus" pButtonIcon></i></button>
      </span>
    }
    @if (this.programTiming?.adjustedWeeks && !showButton) {
      <span>
        ({{programTiming?.adjustedWeeks}})
      </span>
    }
    </div>
    `,
    standalone: false
})
export class ButtonCellRendererComponent {

  constructor(private esciService: EsciService) {
    this.apiUrl = environment.apiUrl;
  }

  params: any;
  showButton: boolean;
  programTiming: ProgramTiming;
  disableButtons = false;
  newProgramTiming: ProgramTiming;
  apiUrl: string;

  agInit(params: any): void {
    this.params = params;
    const programName = this.params.colDef.headerName;
    this.programTiming = this.params.data.programData.get(programName);
    // Only show buttons for math release and ICDe Stage dates.
    // Manually entered ICDe dates are fixed absolute dates - no +/- week buttons (re-edit via the date picker).
    this.showButton = params.data.isAdjustable()
        && !this.programTiming?.manualDateEntered;
    if (params.disableButtons) {
        this.disableButtons = params.disableButtons;
    }
    // if this column is an old timing, we want to find the non-old timing and compare dates
    if (programName.startsWith(KtsComponent.savedTimingPrefix)) {
      // set the difference flag by comparing dates of programs with the same name
      const newProgramTimingName = programName.slice(KtsComponent.savedTimingPrefix.length);
      this.newProgramTiming = this.params.data.programData.get(newProgramTimingName);
    }
  }
  // This method dynamically styles the date values based on whether they've been adjusted
  customStyle(): { [key: string]: string } {
    const comparisonColor = this.newProgramTiming
        && this.newProgramTiming.date?.toDateString() !== this.programTiming?.date?.toDateString()
        ? '#bb1c1c'
        : 'black';
    return {
      'font-weight': (this.programTiming?.adjustedWeeks && this.programTiming?.adjustedWeeks !== 0) ? 'bold' : 'normal',
      'color': comparisonColor
    };
  }
  adjustWeeksMinusOne() {
    this.programTiming.adjustedWeeks -= 1;
    this.esciService.emitTimingAdjustment(this.params.data);
  }
  adjustWeeksPlusOne() {
    this.programTiming.adjustedWeeks += 1;
    this.esciService.emitTimingAdjustment(this.params.data);
  }
}
